import React from 'react';
import { useParams } from 'react-router';

import ActionButton from '@components/button/ActionButton';
import useSingleLeadOrganisationSync from './hooks/useSingleLeadOrganisationSync';

const LeadOrganisationSingleSync: React.FC = () => {
    const { id } = useParams<ParamType>();
    const { isSyncing, handleSync } = useSingleLeadOrganisationSync(id);

    return (
        <ActionButton
            color="blue"
            icon={`sync ${isSyncing ? 'fa-spin' : ''}`}
            isPosting={isSyncing}
            onClick={handleSync}
        >
            Sync
        </ActionButton>
    );
};

type ParamType = { id: string };

export default LeadOrganisationSingleSync;
